/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */

import { useState, useEffect } from 'react';

export default function useSideNavbarCollapsedState(initState) {
  const [isOpen, setIsOpen] = useState(initState);

  const onToggleClick = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleGlobalToggle = (e) => {
      const shouldOpen = e.detail?.open;
      if (shouldOpen !== undefined) {
        setIsOpen(shouldOpen);
      } else {
        setIsOpen(prev => !prev);
      }
    };

    window.addEventListener('nx-sidebar-toggle', handleGlobalToggle);
    return () => window.removeEventListener('nx-sidebar-toggle', handleGlobalToggle);
  }, []);

  // onToggleClick is retained for the legacy LeftNavigationMenu.jsx consumer
  // (Classic ExtJS-style nav, not currently rendered by the cloud-ui App). New
  // consumers should dispatch the `nx-sidebar-toggle` window event instead.
  return [isOpen, onToggleClick];
}
